<template>
  <div class="lp-index">
    <div class="header__image">
      <div class="header__image__inner">
        <div class="header__text">
          <h2><span class="header__text__main--small">業務の提案・進行・管理をサポート</span><span
              class="header__text__main--big">バックオフィス業務の<br><span class="strong">すべてがラクラク</span>に</span></h2>
          <div class="header__btns pc-only">
            <div>
              <nuxt-link to="/auth/register" class="button button--accent-red"><span class="big">無料ではじめる<i class="las la-chevron-circle-right"></i></span></nuxt-link>
            </div>
          </div>
        </div>
        <div class="header__thumb">
          <img src="/img/lp/lp_thumb.png" srcset="/img/lp/lp_thumb.png 1x, /img/lp/lp_thumb@2x.png 2x">
        </div>
        <div class="header__btns until-tb">
          <div>
            <nuxt-link to="/auth/register" class="button button--accent-red"><span
                class="small">クレジットカードの登録は不要です</span><span class="big">30日間無料でお試し</span></nuxt-link>
          </div>
        </div>
      </div>
    </div>
    <div id="function" class="copybox">
      <h2 class="copybox__title">モチカケで<br><span class="strong">バックオフィス業務が変わる</span></h2>
      <div class="copybox__concept">
        <img src="/img/lp/copybox_concept.png" srcset="/img/lp/copybox_concept.png 1x, /img/lp/copybox_concept@2x.png 2x">
      </div>
    </div>

    <div class="support">
      <div class="support__card">
        <h3 class="support__copy">幅広い機能</h3>
        <p class="support__copy__text">業務の提案、業務の可視化と進行管理、書類の作成・管理など事務業務をサポートする機能が豊富です。</p>
        <div class="support__list__wrapper">
          <div class="support__item">
            <div class="support__texts">
              <h4 class="support__title">あなたの会社の為に準備した業務の提案</h4>
              <p class="support__text">ミスの許されない法定業務もサービスから適切なタイミングで提案します。業務の詳細な進め方も丁寧に解説。<br>熟練でない担当者でもステップに従うだけで業務が完了します。
              </p>
              <div class="more">
                <nuxt-link to="/function#function-proposal" class="morelink">詳しく見る</nuxt-link>
              </div>
            </div>
            <div class="support__image">
              <img src="/img/lp/support_access.png" alt="あなたの会社の為に準備した業務の提案">
            </div>
          </div>
          <div class="support__item">
            <div class="support__texts">
              <h4 class="support__title">バックオフィス業務を可視化</h4>
              <p class="support__text">
                タスクの進行管理や割り振り機能により手順の決まった法定業務も「だれ」が「いつ」「どこまで」進めているか見える化します。<br>リモートワーク下でも社内の業務を見える化し、抜け漏れのない業務を実現します。</p>
              <div class="more">
                <nuxt-link to="/function#function-proposal" class="morelink">詳しく見る</nuxt-link>
              </div>
            </div>
            <div class="support__image">
              <img src="/img/lp/support_proposal.png" alt="バックオフィス業務を可視化">
            </div>
          </div>
          <div class="support__item">
            <div class="support__texts">
              <h4 class="support__title">直感的な書類管理</h4>
              <p class="support__text">書類のアップロードの際に紐付けたタグをクリックするだけで、探している書類に簡単にアクセス可能です。<br>共有や確認依頼、承認依頼などペーパーレス化を実現します。
              </p>
              <div class="more">
                <nuxt-link to="/function#function-document" class="morelink">詳しく見る</nuxt-link>
              </div>
            </div>
            <div class="support__image">
              <img src="/img/lp/support_custom.png" alt="直感的な書類管理">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="point__bg">
      <div class="point__wrapper">
        <div class="point">
          <div class="point__mark point__mark__proposal bg-blue las la-flag"></div>
          <h4>柔軟な業務ステップの作成</h4>
          <p>提案内容も独自の業務に合わせて編集可能です。</p>
        </div>
        <div class="point">
          <div class="point__mark point__mark__document bg-purple las la-folder-open"></div>
          <h4>タグのカスタマイズ</h4>
          <p>自社の運用に合わせたタグを作成できます。<br>欲しい書類にすぐにアクセスできます。<br>ファイル管理の属人化の脱却が可能です。</p>
        </div>
        <div class="point">
          <div class="point__mark point__mark__upload bg-blue las la-cloud-upload-alt"></div>
          <h4>書類ファイルを一括アップロード</h4>
          <p>別々に管理すると手間がかかる1つの書類に紐づいた複数の書類も関連ファイルとして登録可能です。</p>
        </div>
        <div class="point">
          <div class="point__mark point__mark__file bg-purple las la-file-alt"></div>
          <h4>豊富なテンプレート</h4>
          <p>社内で利用する総務関連の各種書類も無料ダウンロード可能です。<br>あらゆるフォーマットを自由にご利用いただけます。</p>
        </div>
        <div class="point">
          <div class="point__mark point__mark__git bg-blue las la-code-branch"></div>
          <h4>書類のバージョン管理</h4>
          <p>過去の書類も自動でバックアップ保存（3回分）いつでもダウンロードが可能です。</p>
        </div>
        <div class="point">
          <div class="point__mark point__mark__communication bg-purple las la-comments"></div>
          <h4>コミュニケーション</h4>
          <p>アップロードされた書類や提案・TODO毎にコメントが可能。相談などのやり取りがサービス内で完結します。</p>
        </div>
      </div>
    </div>

    <div class="flow">
      <div class="flow__wrapper">
        <h3>導入の流れ</h3>
        <div class="flow__list">
          <div class="flow__item">
            <div class="flow__item__inner">
              <h4>無料会員登録</h4>
              <img src="/img/lp/lp_trialflow1.png" srcset="/img/lp/lp_trialflow1.png 1x, /img/lp/lp_trialflow1@2x.png 2x" class="flow__thumb">
              <p><nuxt-link to="/auth/register">登録画面</nuxt-link>から<br>
                無料登録が可能です。</p>
            </div>
          </div>
          <div class="flow__item">
            <div class="flow__item__inner">
              <h4>３０日間のトライアル</h4>
              <img src="/img/lp/lp_trialflow2.png" srcset="/img/lp/lp_trialflow2.png 1x, /img/lp/lp_trialflow2@2x.png 2x" class="flow__thumb">
              <p>無料お試し中は有料プランの<br>
                全ての機能をご利用いただけます</p>
            </div>
          </div>
          <div class="flow__item">
            <div class="flow__item__inner">
              <h4>トライアル終了後、プラン選択</h4>
              <img src="/img/lp/lp_trialflow3.png" srcset="/img/lp/lp_trialflow3.png 1x, /img/lp/lp_trialflow3@2x.png 2x" class="flow__thumb">
              <p>アカウント設定よりプランを選択いただけます。（無料プラン有）</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import heatMapToolMixin from '~/mixins/heatMapToolMixin';
import registerMixin from '@/mixins/registerMixin';

export default {
  layout: 'frontend/lp-top',
  mixins: [heatMapToolMixin, registerMixin],
  data() {
    return {
      title: '会社手続きナビゲーター　モチカケ',
      visible: false,
      hover: false,
      showRegister: false,
      smallScreen: false,
      extraSmallScreen: false,
      retype_password: '',
      formData: {
        email: '',
      },
    }
  },
  mounted () {
    if (window.innerWidth < 960) {
      this.smallScreen = true;
    }
    if (window.innerWidth < 480) {
      this.extraSmallScreen = true;
    }
  }
}
</script>

<style scoped lang="scss">
.card-register {
  width: 100%;
  margin: 0 auto;
  border: none;
  display: block;
  align-content: center;
  height: auto;
  font-size: 1.8rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  a {
    font-size: 1.8rem;
    @media screen and (max-width: 480px) {
      font-size: 16px;
    }
    @media screen and (max-width: 320px) {
      font-size: 14px;
    }
  }
  .auth {
    &__heading {
      font-size: 1.5em;
      border-bottom: none;
      padding-bottom: 8px;
      @media screen and (min-width: 960px) {
        font-size: 2em;
      }
    }
  }
  .card__body {
    @media screen and (max-width: 460px) {
      padding: 32px 12px;
    }
    .card_form_content {
      max-width: 900px;
      margin: 0 auto;
      text-align: center;
      &.center-form {
        max-width: unset;
        margin: unset;
        display: flex;
        .form {
          width: 100%;
          max-width: 900px;
          margin: auto;
        }
      }
    }
  }
  .auth__register__section {
    min-height: 100px;
    max-width: 560px;
    margin: 0 auto;
    input {
      text-align: center;
    }
    select:not([multiple]) {
      text-align-last: center;
    }
    &.mail_register_form {
      margin-top: 40px;
      margin-bottom: 40px;
      input {
        text-align: center;
      }
    }
  }
  .group-register-input {
    input:not([type='radio']),
    select:not([multiple]) {
      border: 0; /* no unit */
      border-bottom: 2px solid #dee2ed;
      height: 47px;
      &:focus {
        box-shadow: none;
      }
    }
  }
  .small-text {
    @media screen and (max-width: 480px) {
      font-size: 16px;
    }
    @media screen and (max-width: 320px) {
      font-size: 14px;
    }
  }
}
</style>
